export const LOCATION_PERIOD_LABELS = {
  jour: 'jour',
  semaine: 'semaine',
  mois: 'mois',
};

export const locationPriceSuffix = (annonce) => {
  if (!annonce || annonce.type !== 'location') return '';
  return `/${LOCATION_PERIOD_LABELS[annonce.periodeLocation] || 'mois'}`;
};

export const formatListingPrice = (annonce) => {
  if (!annonce) return '';
  const prix = Number(annonce.prix || 0);
  if (!prix) return 'Prix sur demande';
  return `${new Intl.NumberFormat('fr-GN', { maximumFractionDigits: 0 }).format(prix)} GNF${annonce.type === 'location' ? ` ${locationPriceSuffix(annonce)}` : ''}`;
};
